export default "__VITE_ASSET__BHNt7oaX__"